var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.948 5.597C16.159 4.24 14.116 3.5 12 3.5c-3.608 0-6.97 2.138-9.31 5.838-.92 1.45-.92 3.885 0 5.334.807 1.275 1.747 2.375 2.77 3.258m2.881 1.81A9.37 9.37 0 0 0 12 20.5c3.608 0 6.97-2.138 9.31-5.838.92-1.45.92-3.885 0-5.334a16.686 16.686 0 0 0-1.083-1.511m-4.64 4.902c-.266 1.45-1.44 2.632-2.882 2.899m-.991-3.33L4.08 19.966M19.92 4.034l-7.634 7.678m2.3-2.312-5.172 5.2A3.668 3.668 0 0 1 8.341 12 3.665 3.665 0 0 1 12 8.32a3.63 3.63 0 0 1 2.586 1.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.0e51b5c744372c6cbac34b2b5e35a82c.svg";
export { ForwardRef as ReactComponent };